import React from "react";
import useTranslate from "../../hooks/useTranslate";

// Post-report confirmation (QAL-T6, frame 1h·2): the reported object
// collapses to this row — blue check disc, "Thanks, reported.", review
// line, Undo text link. Undo restores the card client-side (the report is
// removed server-side); after a reload the object is gone for this
// requester anyway (contract §4).
//
// `card` draws the standalone white card (feed / detail post). Comment rows
// sit inside an existing card/column, so they render the same content
// without the card chrome (comment variant = workorder-sanctioned copy
// fill; the frame draws only the post wording).
const LoungeReportedNotice = ({ type = "post", card = true, onUndo, undoing = false }) => {
  const { t } = useTranslate();
  const body =
    type === "post"
      ? t("Our team will review this post. It stays hidden from your feed in the meantime.")
      : t("Our team will review this comment. It stays hidden from your feed in the meantime.");

  return (
    <div
      data-testid="reported-notice"
      className={
        card
          ? "bg-white border border-[#E4E9F0] rounded-[14px] p-[15px] sm:p-[18px_20px] flex gap-3 items-start"
          : "py-[13px] sm:py-0 flex gap-3 items-start"
      }
    >
      <div className="w-[34px] h-[34px] rounded-full bg-[#EDF4FF] flex items-center justify-center shrink-0">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M3.5 8.5l3 3 6-6.5"
            stroke="#2283FF"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <p className="m-0 text-[14px] font-semibold text-[#111827]">
          {t("Thanks, reported.")}
        </p>
        <p className="m-0 mt-1 text-[13px] leading-[1.5] text-[#6B7280]">{body}</p>
        <button
          type="button"
          onClick={onUndo}
          disabled={undoing}
          data-testid="reported-undo"
          className={`border-none bg-transparent p-0 mt-2 text-[13px] font-semibold text-[#2283FF] ${
            undoing ? "opacity-50" : "cursor-pointer hover:underline"
          }`}
        >
          {t("Undo")}
        </button>
      </div>
    </div>
  );
};

export default LoungeReportedNotice;
